var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-by-side__caption"},[_vm._v(" "+_vm._s(_vm.item.caption)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }